import sdl from '@jds/react-generated-sdl/JDSHorizontalStepItem';
import type { JDSHorizontalStepItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSHorizontalStepItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'undefined',
    itemsType = 'undefined',
    direction = 'both',
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, itemsType, direction, ariaLabel, ...rest },
    'JDSHorizontalStepItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const HorizontalStepItem = withLogic(
  Component
) as React.FC<JDSHorizontalStepItemProps> & { slotName?: string };

HorizontalStepItem.displayName = 'HorizontalStepItem';
HorizontalStepItem.slotName = 'jds_horizontal_step_item';

export { HorizontalStepItem, type JDSHorizontalStepItemProps };
